module.exports = {"slug":"projects","title":"Projects","className":"yellow","html":"<p>As I both <a href=\"/#about-me\">design and code</a>, my work stretches across typically discrete realms. I work individually and on teams, as the project suits; I create designs that others build and build designs others have made. Contact me to so that I can provide some past examples that match your need and intent.</p>\n"};


//////////////////
// WEBPACK FOOTER
// ./markdown/projects.md
// module id = 638
// module chunks = 35783957827783